import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { SlidersHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button.jsx";
import PriceFilter from "@/components/products/PriceFilter.jsx";
import { usePage } from "@inertiajs/react";
import ProductPropertyFilter from "@/components/products/ProductPropertyFilter.jsx";
import { Heading } from "@/components/ui/heading.jsx";
import Sorting from "@/components/products/Sorting.jsx";
import FilterHandler from "@/lib/products/filter";
import TaxonsFilter from "./TaxonsFilter";
import { allowedProductPropertiesFilters } from "../../lib/utils";

export default function () {
  const { filters, taxon } = usePage().props;
  const { product_properties } = filters;
  const filterHandler = new FilterHandler();
  const product_properties_filters = allowedProductPropertiesFilters(
    taxon,
    product_properties
  );
  
  return (
    <Sheet>
      <SheetTrigger>
        <Button variant={"ghost"} className="text-xl">
          <SlidersHorizontal size={30} />
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="">
        <div className="pt-16 p-4 overflow-scroll scrollbar-thin scrollbar-thumb-gray-100 scrollbar-track-gray-50 space-y-8">
          <div className="space-y-4">
            <Heading size="h4">Сортировка</Heading>
            <Sorting />
          </div>
          <div className="space-y-4">
            <Heading size="h4">Цена</Heading>
            <PriceFilter />
          </div>

          {taxon.display_children_taxons_filter && (
            <div className="space-y-4">
              <Heading size="h4">Категории</Heading>
              <TaxonsFilter
                taxons={taxon.children}
                onValuesChange={(values) => {
                  filterHandler.applyTaxonsFilter(values);
                  filterHandler.navigate();
                }}
              />
            </div>
          )}

          <div className="space-y-8">
            {product_properties_filters.map((productPropertyFilter) => {
              const handelPropertyFilterChange = (values) => {
                const filterKey = `filter[properties][${productPropertyFilter.name}]`;
                filterHandler.applyProductPropertyFilter(filterKey, values);
                filterHandler.navigate();
              };
              return (
                <div className="space-y-4">
                  <Heading size="h4">
                    {productPropertyFilter.presentation}
                  </Heading>
                  <ProductPropertyFilter
                    productPropertyFilter={productPropertyFilter}
                    onValuesChange={handelPropertyFilterChange}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
